import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AppVersion } from '@ionic-native/app-version';

import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class AuthProvider {
	url: any;

	constructor(
		private appVersion: AppVersion,
		public platform: Platform, 
		public http: Http,
		public storage: Storage,
		public globals: Globals,
		public httpHelper: HttpHelper
		) {
		console.log('Hello AuthProvider Provider');
	}		
	
	ping(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'auth/ping';

			console.log("in ping");

		    this.http
		    .get(
		    	this.url, 
		    	this.httpHelper.configOptionsWithToken(this.globals.loginData.access_token)
		    )
		    .map(res=>res.json())
		    .subscribe(
		        data => {
		        	console.log("in ping data");
			    	resolve(true);
		       	},
		        err => {
		        	console.log("in ping err");
		        	console.log(err);
		        	reject(err)
		        }
		    );
		});

	}

	login(data){	
		let body =  'grant_type=' + data.grant_type +
					'&username='+ data.username + this.globals.whiskeyId +
					'&password='+ data.password;

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'token';

		    this.http
		    .post(this.url, body, this.httpHelper.configOptionsForPost())
		    .map(res=>res.json())
		    .subscribe(
		        data => {
		        	this.globals.loginData = data;
			        this.storage.set('loginData', {access_token: this.globals.loginData.access_token}).then(()=>{

			          this.getRole((data)=>{
			            this.storage.set('role', data);
			            
			            resolve(data)
			          })
			        })
		       	},
		        err => {reject(err)}
		    );
		});
	}

	fbLogin(result){	
		// let body =  { 
		// 				provider: "Facebook", 
		// 		       	token: result.authResponse.accessToken 
		// 		    };

		let body =  { 
						Provider: "Facebook", 
				       	Token: result 
				    };

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/JwtFromProviderAccessToken';

		    this.http
		    .post(this.url, body, this.httpHelper.configOptionsForPostPayload())
		    .map(res=>res.json())
		    .subscribe(
		        data => {
		        	this.globals.loginData.access_token = data;
			        this.storage.set('loginData', {access_token: this.globals.loginData.access_token}).then(()=>{

			          this.getRole((data)=>{
			            this.storage.set('role', data);
			            
			            resolve(data)
			          })
			        })
		        },
		        err => {reject(err)}
		    );
		});
	}	

	register(data){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/register';

		    this.http
		    .post(this.url, data, this.httpHelper.configOptionsForPostPayload())
		    .map(res=> {
		    	return res;
		    })
		    .subscribe(
		        data => {resolve(data)},
		        err => {reject(err)}
		    );
		});
	}   

	logMessage(msg){
		// return new Promise( (resolve, reject) => {
		// 	this.url = this.globals.dataUrl + 'auth/log';

		//     this.http
		//     .post(this.url, {Message:msg}, this.httpHelper.configOptionsForPostPayload())
		//     .map(res=> {
		//     	return res;
		//     })
		//     .subscribe(
		//         data => {resolve(data)},
		//         err => {reject(err)}
		//     );
		// });
	}   

	registerBusiness(data){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/register/business';

		    this.http
		    .post(this.url, data, this.httpHelper.configOptionsForPostPayload())
		    .map(res=> {
		    	return res;
		    })
		    .subscribe(
		        data => {resolve(data)},
		        err => {reject(err)}
		    );
		});
	}  	
	
	getRole(cb){
		this.url = this.globals.dataUrl + 'account/role';

		this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		    	this.url, 
		    	this.httpHelper.configOptionsWithToken(loginData.access_token))
		    .map(res => res.json())
			.subscribe(data => {
		        if(typeof cb == "function") cb(data[0]);
		    });    
		});
	}

	verifyVersionUpToDate(cb){
		this.platform.ready().then((readySource) => {
	        if(readySource!="dom"){
				this.url = this.globals.dataUrl + 'auth/whiskey/' + this.globals.whiskeyId + '/version/list';

			    this.http.get(
			    	this.url, 
			    	null
			   	)
			    .map(res => res.json())
				.subscribe(res => {
					var versionList = res.Data;

					this.appVersion.getVersionNumber().then((version)=> {
						var currentVersionIsLatest = false;

						console.log("App Version: " + version);

						console.log("CurrentVersionList: ");
						console.log(versionList);

						var versionFound = false;

						for (var i = versionList.length - 1; i >= 0; i--) {
							if(versionList[i].ConfigValue == version){
								versionFound = true;
							}
						}

						if(versionFound){
							currentVersionIsLatest = true;
						}

				        if(typeof cb == "function") cb(currentVersionIsLatest);			    					    		
					});	 
			    });  	          
	        }else{
	        	cb(true);
	        }
		})
	}

	requestPasswordChange(data){

		let body =  'username='+ data.username;

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/requestPasswordChange';

		    this.http
		    .post(this.url, body, this.httpHelper.configOptionsForPost())
		    .map(res=> {
		    	return res;
		    })
		    .subscribe(
		        data => {resolve(data)},
		        err => {reject(err)}
		    );
		});
	}   	

	validatePasswordCode(data){
		let body =	'username='+ data.username +
					'&passwordCode='+ data.passwordCode;

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/validatePasswordCode';

		    this.http
		    .post(this.url, body, this.httpHelper.configOptionsForPost())
		    .map(res=> {
		    	return res.json();
		    })
		    .subscribe(
		        data => {resolve(data.Data)},
		        err => {reject(err)}
		    );
		});
	}

	changePassword(data){
		let body =	'grant_type=' + data.grant_type +
					'&password='+ data.password +
					'&username='+ data.username +
					'&passwordCode='+ data.passwordCode;

		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'account/whiskey/' + this.globals.whiskeyId + '/changePassword';

		    this.http
		    .post(this.url, body, this.httpHelper.configOptionsForPost())
		    .map(res=> {
		    	return res.json();
		    })
		    .subscribe(
		        data => {resolve(data.Success)},
		        err => {reject(err)}
		    );
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/auth.ts